import { c as _c } from "react/compiler-runtime";
import { useUserLocation } from "@/hooks/use-user-location";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import React from "react";
export const CenterMarker = React.memo(function CenterMarker() {
  const $ = _c(3);
  const {
    userLocation
  } = useUserLocation();
  if (!userLocation) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative w-8 h-8 flex items-center justify-center"><div className="absolute w-8 h-8 bg-blue-200 rounded-full opacity-40" /><div className="absolute w-6 h-6 bg-blue-300 rounded-full opacity-50 animate-pulse" /><div className="absolute w-4 h-4 bg-blue-600 rounded-full border-2 border-white" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== userLocation) {
    t1 = <AdvancedMarker position={userLocation} zIndex={50}>{t0}</AdvancedMarker>;
    $[1] = userLocation;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
});